import { render, staticRenderFns } from "./Medication.vue?vue&type=template&id=70eb4399&scoped=true"
import script from "./Medication.vue?vue&type=script&lang=js"
export * from "./Medication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70eb4399",
  null
  
)

export default component.exports